import { classNames } from 'primereact/utils'

const badge = {
    root: ({ props }: { props: any }) => ({
        className: classNames(
            //Font
            'text-2xs font-medium',
            //Alignments
            'inline-flex items-center justify-center',
            //Spacing
            'px-1.5 py-1',
            //Shape
            {
                'rounded-md': !props.rounded,
                'rounded-full': props.rounded,
            },
            //Colors
            'text-grey-7',            
            {
                'bg-grey-3 ': !props.severity || props.severity === 'primary',
                'bg-faded-green border border-accent-green': props.severity == 'success',
                'bg-faded-yellow border border-warning-yellow text-allstate-navy': props.severity == 'warning',
            },
        ),
    }),
    value: ({ props }): { props: any } => ({
        className: classNames(
            'leading-normal',
            {
                'text-allstate-navy': ['warning', 'success'].includes(props.severity),
            }
        ),
    }),
    icon: ({ props }): { props: any } => ({
        className: classNames(
            'mr-1 text-sm',
            {
                'text-warning-yellow': props.severity === 'warning',
                'text-accent-green': props.severity === 'success',
            }
        ),
    }),
}

export default badge
